// extracted by mini-css-extract-plugin
export var blue = "_26-g";
export var brand = "_26-c";
export var darkGrey = "_26-f";
export var disabled = "_26-6";
export var disabledSubtle = "_26-7";
export var error = "_26-8";
export var green = "_26-h";
export var grey = "_26-e";
export var icon = "_26-0";
export var inherit = "_26-b";
export var lightGrey = "_26-d";
export var orange = "_26-j";
export var pink = "_26-l";
export var primary = "_26-1";
export var purple = "_26-m";
export var quaternary = "_26-4";
export var quinary = "_26-5";
export var red = "_26-k";
export var secondary = "_26-2";
export var success = "_26-a";
export var tertiary = "_26-3";
export var warning = "_26-9";
export var white = "_26-n";
export var yellow = "_26-i";